export function Format(target: string, ...args) {
    let raw;

    raw = target;

    if (args.length === 1 && typeof args[0] === 'object') {
        if (Array.isArray(args[0])) {
            args = args[0];
            for (let i = 0; i < args.length; i++) {
                if (args[i] === undefined) {
                    return '';
                }

                    const reg = new RegExp(`({[${  i  }]})`, 'g');

                    let val = args[i];

                    if (typeof val === 'string') {
                        // 将值里面的 $1 替换成 $$1
                        val = val.replace(/\$1/g, '$$$1');
                    }
                    raw = raw.replace(reg, val);
            }
        } else {
            const obj = args[0];

            for (const key in obj) {
                const reg = new RegExp(`({${  key  }})`, 'g');

                let val = obj[key];

                if (val !== null && typeof val === 'string') {
                    // 将值里面的 $1 替换成 $$1
                    val = val.replace(/\$1/g, '$$$1');
                }
                raw = raw.replace(reg, val);
            }
        }
    } else {
        for (let i = 1; i < arguments.length; i++) {
            if (arguments[i] === undefined) {
                return '';
            }

                const reg = new RegExp(`({[${  i - 1  }]})`, 'g');

                let val = arguments[i];

                if (typeof val === 'string') {
                    // 将值里面的 $1 替换成 $$1
                    val = val.replace(/\$1/g, '$$$1');
                }
                raw = raw.replace(reg, val);
        }
    }
    return raw;
}

export function trim(str) {
    try {
        return str.replace(/(^\s*)|(\s*$)/g, '');
    } catch (e) {
        return str;
    }
}
export function startsWith(str, suffix): boolean {
    return str.indexOf(suffix) === 0;
}
export function endsWith(str: string, suffix): boolean {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

export function html_encode(html) {
    // 1.首先动态创建一个容器标签元素，如DIV
    let temp = document.createElement('div');
    // 2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(火狐，google支持)

    (temp.textContent != undefined) ? (temp.textContent = html) : (temp.innerText = html);
    // 3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
    const output = temp.innerHTML;

    temp = null;
    return output;
}

export function html_decode(text) {
    // 1.首先动态创建一个容器标签元素，如DIV
    let temp = document.createElement('div');
    // 2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)

    temp.innerHTML = text;
    // 3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
    const output = temp.innerText || temp.textContent;

    temp = null;
    return output;
}

/**
 * 格式化金额
 * @param amount 金额(分)
 */
export function formatMoney(amount: number) {
    return (amount / 100).toFixed(2);
}

export function trimEnd(str: string, chars) {
    if (endsWith(str, chars)) {
        return str.substring(0, str.length - chars.length);
    }
    return str;
}

export function trimStart(str: string, chars: string) {
    if (startsWith(str, chars)) {
return str.substring(chars.length, str.length);
}
    return str;
}

export function isEmptyOrNull(str: string) {
    if (str && str != '') {
        return false;
    }
    return true;
}

export function defaultValue(str, defaultValue) {
    if (str == null) {
        return defaultValue;
    }
    return str;
}
export function convertTextLinksToTargetBlank(text) {
    const el = document.createElement('div');

    el.innerHTML = text;
    const links = el.getElementsByTagName('a');

    if (links.length === 0) {
        return text;
    }

  for (const link of links) {
   if (!link.hasAttribute('target')) {
     link.setAttribute('target', '_blank');
   }
  }
  return el.outerHTML;
}
export const getWordsCount = (data) => {
    const span = document.createElement('span');

    span.innerHTML = data;
    const text = span.textContent || span.innerText;

    if (!_.size(text)) return 0;

    let cont = data.replace(/<[^>]*>/g, ' ');

    cont = cont.replace(/\s+/g, ' ');
    cont = cont.trim();
    return cont.length;
  };

